/* globals angular */
( function () {
	'use strict';
	/* eslint max-params:0 */
	function Indicator ( $q, dataservice, logger, templateservice, $modal, msg, collectionService, indicatorService, apiService ) {
		var self     = this;
		var selected = [];

		function templateAttachmentMapper ( item ) {
			return {
				'ContentName' : item.ContentName,
				'ContentId'   : item.ContentId
			};
		}

		function pdOnly ( item ) {
			// making sure that we only count PD in templateAttachments
			return item.hasOwnProperty( 'ContentId' ) || item.fileType === 19 || item.type === 3;
		}

		function updateSelectedPd ( selectedPd ) {
			selected         = selectedPd;
			self.numberOfPPD = ( selected || [] ).length;

			self.model.templateAttachments = ( selected || [] ).map( templateAttachmentMapper );
		}

		self.editModeHandler = function () {
			self.model.state = angular.copy( self.model );
			self.mode        = 'edit';
			self.viewMode    = false;
		};

		self.saveHandler = function () {
			self.model.state = void 0;
			self.mode        = 'view';
			self.viewMode    = true;
		};

		self.cancelHandler = function () {
			self.model    = self.model.state;
			self.mode     = 'view';
			self.viewMode = true;
		};

		function activate () {
			self.readOnly = true;

			// check initial value of disable description checkbox
			self.rubricDescriptionFlag = !( self.model.answerOptions && ( self.model.answerOptions[ 0 ] || {} ).description );

			logger.info( 'Activated Indicator View' );
		}

		function digitsOnly ( option ) {
			return templateservice.digitsOnly( option, 'score' );
		}

		function openConfirmationModal () {
			if ( ( self.groupModel.formula || '' ).indexOf( self.model.id ) > -1 ) {
				logger.notifyError( msg.indicatorDeleteError );
				return;
			}

			$modal.open( {
				'templateUrl'  : '/templates/components/delete-modal/delete-confirmation.html',
				'controller'   : 'DeleteConfirmationController',
				'controllerAs' : 'vm',
				'keyboard'     : false,
				'resolve'      : {
					'type' : function () {
						return 'Indicator';
					}
				}
			} ).result.then( function () {
				self.onDelete();
			} );
		}

		function isMultipleChoiceOrRubric () {
			var type = Number( self.model.type );

			return ( type === 2 || type === 4 || type === 3 );
		}

		function isLabel () {
			var type = Number( self.model.type );

			return type === 5;
		}

		function copyIndicatorHandler ( ) {
			var modelCopy                = angular.copy( self.model );
			var indicatorModel           = indicatorService.getData( self.model.type );

			indicatorModel.id            = apiService.generateUUID();
			indicatorModel.questionText  = modelCopy.questionText;
			indicatorModel.answerOptions = modelCopy.answerOptions;
			indicatorModel.isRequired    = modelCopy.isRequired;
			collectionService.addModelAtIndex( self.groupModel.indicators, indicatorModel, self.index + 1 );
			self.getIndex = 'gr' + self.groupIndex + 'in' + ( self.groupModel.indicators.length - 1 );
			logger.notifySuccess( 'Item copied.' );
		}

		function disableRubricDescription ( flag, rubricOptions ) {
			function deleteDescription ( option ) {
				delete option.description;
			}

			function setDescription ( option, index ) {
				option.description = option.description || 'Description ' + Number( index + 1 );
			}

			function checkFlag ( option, index ) {
				( flag && deleteDescription || setDescription )( option, index );
			}

			rubricOptions.forEach( checkFlag );
		}

		self.updateSelectedPd         = updateSelectedPd;
		self.digitsOnly               = digitsOnly;
		self.openConfirmationModal    = openConfirmationModal;
		self.tooltip                  = msg.tooltipMessages;
		self.pdOnly                   = pdOnly;
		self.isMultipleChoiceOrRubric = isMultipleChoiceOrRubric;
		self.isLabel                  = isLabel;
		self.copyIndicator            = copyIndicatorHandler;
		self.disableRubricDescription = disableRubricDescription;

		activate();
	}

	function templateIndicatorConfig ( $provide, TOOLTIP_MESSAGES, ERROR_MSGS ) {
		$provide.constant( 'templateIndicatorMessages', {
			'tooltipMessages'      : TOOLTIP_MESSAGES,
			'indicatorDeleteError' : ERROR_MSGS.indicatorDeleteError
		} );
	}

	angular
		.module( 'app.templates' )
		.config( templateIndicatorConfig )
		.controller( 'Indicator', Indicator );

	templateIndicatorConfig.$inject = [ '$provide', 'TOOLTIP_MESSAGES', 'ERROR_MSGS' ];
	Indicator.$inject               = [ '$q', 'coreservice', 'logger', 'templateservice', '$modal', 'templateIndicatorMessages', 'collectionService', 'indicatorService', 'apiService' ];
} )( );
